export const SUC_UPDATE_NODEPARM_MAX = 20;
export const SUC_UPDATE_ENTRY_SIZE = 2 + SUC_UPDATE_NODEPARM_MAX;
export const SUC_MAX_UPDATES = 64;

// The highest supported protocol file format
export const MAX_PROTOCOL_FILE_FORMAT = 5;
